import React from 'react'
import { Box, Container } from '@mui/material'
import { Helmet } from 'react-helmet'
import LeaderboardHeader from './components/LeaderboardHeader'
import LeaderboardTab from './components/LeaderboardTab'

const Leaderboard: React.FC = () => {
  return (
    <Container component="main" sx={{ flex: 1 }}>
      <Helmet>
        <title>Resactly | Points & Leaderboard</title>
      </Helmet>
      <Box>
        <LeaderboardHeader />
        <LeaderboardTab />
      </Box>
    </Container>
  )
}

export default Leaderboard
